var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSourceInvoice = function SvgSourceInvoice(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75002 6.70801C4.75002 6.17874 5.17908 5.74967 5.70835 5.74967H11.4584C11.9876 5.74967 12.4167 6.17874 12.4167 6.70801C12.4167 7.23728 11.9876 7.66634 11.4584 7.66634H5.70835C5.17908 7.66634 4.75002 7.23728 4.75002 6.70801Z",
    fill: "#082344"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70835 10.0622C5.17908 10.0622 4.75002 10.4912 4.75002 11.0205C4.75002 11.5498 5.17908 11.9788 5.70835 11.9788H11.4584C11.9876 11.9788 12.4167 11.5498 12.4167 11.0205C12.4167 10.4912 11.9876 10.0622 11.4584 10.0622H5.70835Z",
    fill: "#082344"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75002 15.333C4.75002 14.8037 5.17908 14.3747 5.70835 14.3747H11.4584C11.9876 14.3747 12.4167 14.8037 12.4167 15.333C12.4167 15.8623 11.9876 16.2913 11.4584 16.2913H5.70835C5.17908 16.2913 4.75002 15.8623 4.75002 15.333Z",
    fill: "#082344"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2917 7.66634C15.821 7.66634 16.25 7.23728 16.25 6.70801C16.25 6.17874 15.821 5.74967 15.2917 5.74967H15.2869C14.7576 5.74967 14.3286 6.17874 14.3286 6.70801C14.3286 7.23728 14.7576 7.66634 15.2869 7.66634H15.2917Z",
    fill: "#082344"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 11.0205C16.25 11.5498 15.821 11.9788 15.2917 11.9788H15.2869C14.7576 11.9788 14.3286 11.5498 14.3286 11.0205C14.3286 10.4912 14.7576 10.0622 15.2869 10.0622H15.2917C15.821 10.0622 16.25 10.4912 16.25 11.0205Z",
    fill: "#082344"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2917 16.2913C15.821 16.2913 16.25 15.8623 16.25 15.333C16.25 14.8037 15.821 14.3747 15.2917 14.3747H15.2869C14.7576 14.3747 14.3286 14.8037 14.3286 15.333C14.3286 15.8623 14.7576 16.2913 15.2869 16.2913H15.2917Z",
    fill: "#082344"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916687 3.35384C0.916687 2.03066 1.98934 0.958008 3.31252 0.958008H17.6875C19.0107 0.958008 20.0834 2.03066 20.0834 3.35384V19.6455C20.0834 20.9687 19.0107 22.0413 17.6875 22.0413H3.31252C1.98934 22.0413 0.916687 20.9687 0.916687 19.6455V3.35384ZM3.31252 2.87467C3.04788 2.87467 2.83335 3.0892 2.83335 3.35384V19.6455C2.83335 19.9101 3.04788 20.1247 3.31252 20.1247H17.6875C17.9522 20.1247 18.1667 19.9101 18.1667 19.6455V3.35384C18.1667 3.0892 17.9522 2.87467 17.6875 2.87467H3.31252Z",
    fill: "#082344"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSourceInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source-invoice.11999a64.svg";
export { ForwardRef as ReactComponent };